// tile status
export const ACTIVE = 'active';
export const ARCHIVE = 'archive';
export const DRAFT = 'draft';
export const PLAN = 'plan';
export const IGNORED = 'ignored';
export const USER_SUBMITTED = 'user_submitted';
